<template>
	<div style="padding: 0.22rem;">
		<div>
			<div class="left_title">交易管理</div>
			<div @click="leftGoto('/tradingRecord')" class="left_tab"
				:class="left_tabShow == 'trading_record'?'left_tab_select':''">交易记录</div>
			<div class="left_tab" @click="leftGoto('/withdraw')" :class="left_tabShow == 'withdraw'?'left_tab_select':''" >提现</div>
		</div>
		<div>
			<div class="left_title">银行卡管理</div>
			<div class="left_tab" :class="left_tabShow == 'bank_card'?'left_tab_select':''" @click="leftGoto('/bankCard')">我的银行卡</div>
		</div>
		<div>
			<div class="left_title">订单管理</div>
			<div class="left_tab"  :class="left_tabShow == 'my_order'?'left_tab_select':''" @click="leftGoto('/myOrder')">我的订单</div>
			<div @click="leftGoto('/myDebit')" class="left_tab" :class="left_tabShow == 'my_debit'?'left_tab_select':''">我的发票</div>
		</div>



	</div>
</template>

<script setup>
	defineProps({
		left_tabShow: String
	})

	import {
		useRouter
	} from "vue-router";
	const router = useRouter();
	//直接跳转
	const leftGoto = (type) => {
		console.log('dianji ', type);
		router.push(type);
	};
</script>

<style scoped>
	.left_title {

		font-size: 0.12rem;
		margin-bottom: 0.2rem;
		color: #86909C;
	}

	.left_tab {
		font-size: 0.18rem;
		margin-bottom: 0.2rem;
		color: #333333;
		cursor: pointer;
	}

	.left_tab_select {
		color: #C01A26;
	}
</style>